
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import kpiSchedulerTabViewDescriptor from './KpiSchedulerTabViewDescriptor.json'

export default defineComponent({
    name: 'kpi-scheduler-save-dialog',
    components: { Dialog },
    props: { schedulerName: { type: String } },
    emits: ['close'],
    data() {
        return {
            kpiSchedulerTabViewDescriptor,
            name: '' as String,
            nameDirty: false
        }
    },
    computed: {
        nameHelp(): string {
            return (this.name?.length ?? '0') + ' / 40'
        },
        saveSchedulerButtonDisabled(): Boolean {
            return !this.name
        }
    },
    watch: {
        currentRule() {
            this.loadSchedulerName()
        }
    },
    async created() {
        this.loadSchedulerName()
    },
    methods: {
        loadSchedulerName() {
            this.name = this.schedulerName as String
        }
    }
})
